var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.object
      ? _c(
          "a",
          {
            staticClass: "gray-100 dinlineb",
            attrs: { href: _vm.objectOverviewUrl || null, target: "_blank" }
          },
          [
            _c("icon-label", {
              attrs: {
                icon: _vm.object.icon,
                bkgColor: _vm.object.class,
                value: _vm.name,
                placeholder: _vm.placeholder
              }
            })
          ],
          1
        )
      : _c("span", [
          _vm._v("\n            " + _vm._s(_vm.placeholder) + "\n        ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }